const NAMESPACE = "referencesError";

const KEYS = {
    referencesDialogTitle: "referencesDialogTitle",
    viewReferencesButtonLabel: "viewReferencesButtonLabel",
    noReferencesFoundMessage: "noReferencesFoundMessage",
    defaultMessagesTitle: "defaultMessagesTitle",
    defaultRefsTitle: "defaultRefsTitle",
    defaultOkTitle: "defaultOkTitle"
};

const MESSAGES = {
    [KEYS.referencesDialogTitle]: {
        value: "{objectName} References",
        comment: ""
    },
    [KEYS.viewReferencesButtonLabel]: {
        value: "View References",
        comment: ""
    },
    [KEYS.noReferencesFoundMessage]: {
        value: "No program design references found.",
        comment: ""
    },
    [KEYS.defaultMessagesTitle]: {
        value: "Errors:",
        comment: ""
    },
    [KEYS.defaultRefsTitle]: {
        value: "Program design references:",
        comment: ""
    },
    [KEYS.defaultOkTitle]: {
        value: "No blocking references found.",
        comment: ""
    }
};

export { KEYS, NAMESPACE, MESSAGES };
